import styles from "./LCatalogThreeCols.module.css";

/**
 * LCatalogThreeCols — catalog layout 3 kolumny.
 *
 * **Struktura:**
 *   leftSidebar | (catalogContent -> belowCatalog) | rightSidebar
 */
export function LCatalogThreeCols({
  leftSidebar,
  catalogContent,
  belowCatalog,
  rightSidebar,
}: LCatalogThreeColsProps) {
  return (
    <div className={styles.root}>
      <aside className={styles.leftSidebar}>{leftSidebar}</aside>
      <div className={styles.mainColumn}>
        <div className={styles.content}>{catalogContent}</div>
        {belowCatalog ? <div className={styles.below}>{belowCatalog}</div> : null}
      </div>
      <aside className={styles.rightSidebar}>{rightSidebar}</aside>
    </div>
  );
}

export type LCatalogThreeColsProps = {
  leftSidebar: React.ReactNode;
  catalogContent: React.ReactNode;
  belowCatalog: React.ReactNode;
  rightSidebar: React.ReactNode;
};
